import { render, staticRenderFns } from "./SHBXCQ.vue?vue&type=template&id=5da804be&scoped=true"
import script from "./SHBXCQ.vue?vue&type=script&lang=js"
export * from "./SHBXCQ.vue?vue&type=script&lang=js"
import style0 from "./SHBXCQ.vue?vue&type=style&index=0&id=5da804be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da804be",
  null
  
)

export default component.exports